export default function() {
  return window.pageYOffset || document.documentElement.scrollTop;
};
